
export type AggregatedMetricsData = {[key: string]: {[key: string]: number}};
